<div class="input-container">
  <p class="agent-script">Agent validation script</p>
  <textarea [formControl]="validationFieldsFormGroup.controls['validation_script']"></textarea>
  <app-error-display 
    [control]="validationFieldsFormGroup.controls['validation_script']" 
    [customErrorMessageProvider]="getTooltipData.bind(this)">
  </app-error-display>

  <div class="validation-container">
    <p>the script will use the following pieces of information for account validation purposes:
      @for (field of client.validation.fields; track field) {
        <strong>{{field.prompt}}, </strong>
      }
      <strong>CCID.</strong></p>
    </div>
  </div>
